/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OAuthClient } from './OAuthClient';
import {
    OAuthClientFromJSON,
    OAuthClientFromJSONTyped,
    OAuthClientToJSON,
    OAuthClientToJSONTyped,
} from './OAuthClient';

/**
 * 
 * @export
 * @interface UpdateOauthClientResponse
 */
export interface UpdateOauthClientResponse {
    /**
     * 
     * @type {OAuthClient}
     * @memberof UpdateOauthClientResponse
     */
    data: OAuthClient;
}

/**
 * Check if a given object implements the UpdateOauthClientResponse interface.
 */
export function instanceOfUpdateOauthClientResponse(value: object): value is UpdateOauthClientResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateOauthClientResponseFromJSON(json: any): UpdateOauthClientResponse {
    return UpdateOauthClientResponseFromJSONTyped(json, false);
}

export function UpdateOauthClientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOauthClientResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': OAuthClientFromJSON(json['data']),
    };
}

  export function UpdateOauthClientResponseToJSON(json: any): UpdateOauthClientResponse {
      return UpdateOauthClientResponseToJSONTyped(json, false);
  }

  export function UpdateOauthClientResponseToJSONTyped(value?: UpdateOauthClientResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': OAuthClientToJSON(value['data']),
    };
}

